import React from "react";
import { Link } from "react-router-dom";
import SEO from "../utils/SEO";
import { HUB_QUIZZES } from "../../data/quizzes";
import { getQuizIcon } from "./quizIcons";
import "../../styles/Quiz.css";

// Indexable hub listing every quiz — the single nav destination and a landing
// page targeting "wellness quiz / health quiz" search terms.
const QuizzesHub = () => (
  <div className="quiz-hub">
    <SEO
      title="Free Wellness Quizzes — Find Your Natural Path | Sarv"
      description="Take Sarv's free wellness quizzes — sleep, stress, gut health, hormones, immunity, and your Ayurvedic or Five Element type — and get personalized natural remedy recommendations."
      canonicalPath="/quizzes"
      keywords="wellness quiz, health quiz, natural remedy quiz, dosha quiz, sleep quiz, stress quiz, gut health quiz, hormone quiz"
    />

    <div className="quiz-hub__head">
      <h1 className="quiz-hub__title">Find your natural path</h1>
      <p className="quiz-hub__sub">
        Take a free 2-minute quiz to understand your body and get personalized, natural
        recommendations. Wellness guidance only — never a medical diagnosis.
      </p>
    </div>

    <div className="quiz-hub__grid">
      {HUB_QUIZZES.map((quiz) => {
        const Icon = getQuizIcon(quiz.slug);
        return (
          <Link key={quiz.slug} to={quiz.path} className="quiz-hub__card">
            <span className="quiz-hub__icon" aria-hidden="true">
              <Icon />
            </span>
            <div className="quiz-hub__cardtitle">{quiz.title}</div>
            <p className="quiz-hub__cardblurb">{quiz.blurb}</p>
            <span className="quiz-hub__take">Take the quiz →</span>
          </Link>
        );
      })}
    </div>
  </div>
);

export default QuizzesHub;
